<footer class="rcs-footer">
    <div class="container">
        <div class="footer-logo">
            <img src="assets/img/rcs-color.png">
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12 company-info">

                <div class="address-wrapper">
                    <h4 class="footer-heading">Get In Touch with RCS
                    </h4>
                    <p>We are looking for inquiry</p>
                    <div class="address">
                        <p><span>Telephone:</span><a href="tel:+912027691652">+91 9175952264</a></p>
                        <!-- <p><span>Fax:</span><a href="tel:+9120010101010">+91 20 010101010</a></p> -->
                        <p><span>EMail:</span><a href="mailto:enquiry@rcsedesign.com">enquiry@rcsedesign.com
                            </a></p>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 footer-menu">
                <h4 class="footer-heading">Quick Links
                </h4>
                <div class="menu-list">
                    <ul>
                        <li><span>></span><a routerLink="/about-us" href="">About Us</a></li>
                        <!-- <li><span>></span><a href="">Press Release</a></li>
                        <li><span>></span><a href="">Privacy Policy</a></li> -->
                    </ul>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 social-link">
                <h4 class="footer-heading">Quick Links
                </h4>
                <div class="links">
                    <a href=""><img src="assets/icon/facebook.svg"></a>
                    <a href=""><img src="assets/icon/linkdin.svg"></a>
                    <a href=""><img src="assets/icon/twitter.svg"></a>
                </div>
            </div>
        </div>

    </div>
    <div class="footer-bottom">
        <p>© Rahul Consultancy Service, all rights reserved</p>
    </div>
</footer>